import React from 'react';
import { Box } from '@mui/material';
import VacationsSection from '../collaborator/VacationsSection';

const VacationRequestList: React.FC = () => (
    <Box p={3}>
        <VacationsSection />
    </Box>
);

export default VacationRequestList;
